import { createFileRoute } from "@tanstack/react-router";
import { StubAdminPage } from "@/components/admin/StubAdminPage";
import { Map } from "lucide-react";

export const Route = createFileRoute("/admin/city-coverages")({
  component: () => (
    <StubAdminPage
      icon={Map}
      title="City Coverages"
      subtitle="Operating cities and zones across Morocco"
    />
  ),
});
